export interface NewsArticle {
  id: string;
  title: string;
  category: '电影' | '电视剧' | '综艺' | '行业';
  publishedAt: string;
  source: string;
  summary: string;
  cover: string;
  content: string[];
}

export const newsArticles: NewsArticle[] = [
  {
    id: 'n01',
    title: '《长夜将明》定档十月，雨夜追凶预告片发布',
    category: '电影',
    publishedAt: '2026-10-16',
    source: '黄牛视频资讯组',
    summary:
      '由沈知远执导的犯罪悬疑片《长夜将明》正式宣布定档十月二十四日，并发布首支预告。两分十六秒的片段全部发生在暴雨夜，几乎没有一句完整的对白。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20a%20film%20set%20with%20a%20vintage%20camera%20and%20dramatic%20backlight%2C%20deep%20navy%20and%20amber%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n01&orientation=landscape',
    content: [
      '《长夜将明》今日正式宣布定档十月二十四日，并同步放出首支预告片。预告全片没有出现一次晴天，镜头始终在雨幕与霓虹之间游走，周牧饰演的刑警队长郑野在积水里反复走过同一条街道。',
      '导演沈知远在采访中提到，影片的影像基调来自他多年前在南方城市的一次通宵拍摄经历：“那天下了一整夜的雨，整条街只有便利店的灯是亮的。我想把那种‘只要还亮着就还有希望’的感觉拍下来。”',
      '据片方介绍，影片九成以上的场景为实景拍摄，其中一场长达九分钟的长镜头在片中被保留完整。主演林书瑶为角色进行了两个月的体能训练，片中多数奔跑镜头均为亲自完成。',
      '影片将于十月二十四日登陆院线，黄牛视频将在上映后同步更新影片资料页与主创访谈内容。',
    ],
  },
  {
    id: 'n02',
    title: '《长安旧事》收官评分 9.1，群像叙事获好评',
    category: '电视剧',
    publishedAt: '2026-10-15',
    source: '剧集观察',
    summary:
      '播出六周的《长安旧事》于昨晚收官，平台评分稳定在 9.1。观众讨论最多的不是主角，而是西市里那些只出现过两三集的小人物。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20ancient%20Chinese%20lanterns%20glowing%20above%20a%20stone%20street%20at%20night%2C%20deep%20crimson%20and%20navy%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n02&orientation=landscape',
    content: [
      '《长安旧事》昨晚播出最后一集，长达四十二集的群像叙事在收官夜迎来口碑峰值，平台评分最终定格在 9.1。',
      '与常见的古装剧不同，剧集把大量篇幅交给了西市的商贩、驿卒、乐工和守城士兵。编剧团队在前期做了近一年的资料整理，从市井物价到宵禁制度都做了细节还原。',
      '导演陆知行表示，剧组搭建了超过一万两千平方米的实景街区，其中西市部分的店铺可以真正开门营业，演员在没有拍摄任务时也会在街区里生活，以保持状态。',
      '目前该剧已在黄牛视频上线完整剧集资料与角色关系梳理，第二季的筹备消息尚未得到官方确认。',
    ],
  },
  {
    id: 'n03',
    title: '《声浪撞地球》新赛制公布：现场不修音，一次定胜负',
    category: '综艺',
    publishedAt: '2026-10-14',
    source: '综艺前线',
    summary:
      '音乐竞演节目《声浪撞地球》公布新一季赛制，取消复活赛与观众保送机制，每期只有一次登台机会。节目组称这是“把压力还给舞台”。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20a%20concert%20stage%20with%20light%20beams%20and%20haze%2C%20deep%20navy%20and%20orange%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n03&orientation=landscape',
    content: [
      '《声浪撞地球》今日公布新一季赛制。与此前相比，本季取消了复活赛、观众保送与导师加分，每位音乐人每期只有一次登台机会，现场收音不做后期修饰。',
      '节目总导演在发布会上解释：“我们想做的不是一档安全的节目。一次机会、一次现场，唱成什么样就是什么样，这才是live的意义。”',
      '新一季的阵容覆盖摇滚、民谣、说唱与民族音乐四个方向，首期将以合作改编的形式开场。节目将于每周五晚更新，黄牛视频同步更新节目资料与曲目单。',
    ],
  },
  {
    id: 'n04',
    title: '暑期档复盘：中小成本影片为何跑出黑马',
    category: '行业',
    publishedAt: '2026-10-12',
    source: '票房研究所',
    summary:
      '今年暑期档票房结构出现明显变化，成本不足五千万的影片贡献了近三成的票房增量。观众的选择正在变得更挑剔，也更愿意为口碑买单。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20an%20empty%20movie%20theater%20with%20warm%20screen%20glow%20and%20red%20seats%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n04&orientation=landscape',
    content: [
      '暑期档结束，一份来自票务平台的数据显示，成本在五千万以下的中小成本影片合计贡献了近三成的票房增量，这一比例较去年同期上升了十一个百分点。',
      '分析人士认为，短视频平台的口碑扩散速度加快，使得影片的“首周决定论”正在松动。多部影片在上映第二周实现票房逆跌，靠的是观众自发的内容讨论。',
      '与此同时，类型片的边界也在变宽。悬疑、家庭、体育等题材在今年的表现均好于预期，而单纯依赖明星阵容的项目反而承压。',
      '对内容平台而言，这意味着资料页、评分与观众讨论的质量，正在成为用户选择观看的重要参考。',
    ],
  },
  {
    id: 'n05',
    title: '《雪山信使》重映：四年后，我们为什么还需要这个故事',
    category: '电影',
    publishedAt: '2026-10-10',
    source: '影迷手记',
    summary:
      '上映四年后，《雪山信使》以修复版重回大银幕。没有反转、没有奇观，一个送信的人走过一座山，却依然让影院里安静得能听见呼吸。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20a%20snowy%20mountain%20ridge%20at%20sunrise%20with%20a%20tiny%20figure%20walking%2C%20cool%20blue%20and%20golden%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n05&orientation=landscape',
    content: [
      '《雪山信使》的修复版本周起在部分影院重映。这部四年前的作品当年票房并不亮眼，却在之后的几年里被反复提起。',
      '影片的故事极其简单：大雪封山，老信使带着学徒翻越垭口，把一封信送到山那边的村落。全片没有反派，最大的冲突是天气和时间。',
      '导演白岩曾说，他拍的不是英雄，而是“把一件事做完的人”。四年过去，这句话反而更有分量。',
      '修复版对画面做了 4K 重建，声音部分重新混录，高原的风声与呼吸声比原版更清晰。影片资料页已在黄牛视频更新。',
    ],
  },
  {
    id: 'n06',
    title: '《逆风少年》第二季官宣，原班人马回归训练场',
    category: '电视剧',
    publishedAt: '2026-10-09',
    source: '剧集观察',
    summary:
      '青春运动剧《逆风少年》确认开发第二季，第一季主演全员回归。故事将从省级比赛之后讲起，焦点转向队伍的重建。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20a%20running%20track%20at%20sunset%20with%20long%20shadows%2C%20orange%20and%20deep%20blue%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n06&orientation=landscape',
    content: [
      '《逆风少年》官方今日确认第二季正式启动，第一季主演沈澈、梁小满等全员回归，剧本已进入第三稿阶段。',
      '第一季结尾，县中学短跑队拿到了省赛的入场券，但主力队员的伤病与升学压力都被留在了镜头之外。第二季将直接面对这些问题。',
      '制片方透露，新一季会减少比赛场面，把更多篇幅放在训练日常与队员的家庭线上，同时保留每集一次的“跑起来”段落。',
      '第二季预计明年开机。第一季全集资料与角色介绍已在黄牛视频上线。',
    ],
  },
  {
    id: 'n07',
    title: '《推理现场》远洋邮轮特辑：把谜题放进封闭空间',
    category: '综艺',
    publishedAt: '2026-10-08',
    source: '综艺前线',
    summary:
      '新一季《推理现场》把实景现场搬到了一艘远洋邮轮上，六位玩家将在四天三夜里完成一个连续案件。节目组为此改造了三层甲板。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20a%20dim%20room%20with%20a%20desk%20lamp%20and%20scattered%20files%2C%20dark%20teal%20and%20amber%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n07&orientation=landscape',
    content: [
      '《推理现场》新一季宣布采用“连续案件”结构，六位玩家将在远洋邮轮上度过四天三夜，案件不再单期收束，而是随着航行逐层展开。',
      '节目组透露，为了搭建现场，制作团队改造了邮轮的三层甲板，共设置二十六个可搜证空间，其中三个房间的线索只有在特定时间才会出现。',
      '与以往相比，本季减少了提示卡的发放数量，玩家需要依靠人物关系与时间线自行推进。总导演称这是“最难的一季，也是对观众最友好的一季”。',
      '节目每周三更新，黄牛视频将同步更新每期案件的关系图谱。',
    ],
  },
  {
    id: 'n08',
    title: '经典修复计划启动：首批十二部老片将重登大银幕',
    category: '行业',
    publishedAt: '2026-10-05',
    source: '电影资料馆',
    summary:
      '一项面向经典影片的修复计划今日启动，首批十二部作品将在未来两年内完成 4K 修复，并在全国艺联院线分批重映。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20film%20reels%20and%20a%20vintage%20projector%20in%20a%20dark%20archive%20room%2C%20warm%20amber%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n08&orientation=landscape',
    content: [
      '经典影片修复计划今日正式启动，首批十二部作品涵盖上世纪五十年代至九十年代的剧情片、纪录片与动画，修复周期预计为两年。',
      '技术团队介绍，修复工作包括胶片清洁、扫描、色彩校正与声音重建四个阶段，单部影片的平均处理时间超过三个月。部分影片的原始底片已有不同程度损伤，需要逐帧修补。',
      '首批影片将在全国艺联院线分批重映，同时在内容平台上线修复版资料页与幕后纪录短片。',
      '“修复不只是让画面变清楚，”项目负责人说，“而是让后来的观众知道，这些片子当年是怎么被拍出来的。”',
    ],
  },
  {
    id: 'n09',
    title: '《喜剧工坊》第五期：把加班写进段子的人',
    category: '综艺',
    publishedAt: '2026-10-03',
    source: '综艺前线',
    summary:
      '本周《喜剧工坊》的主题是“我的工作”。四组演员交出了完全不同风格的文本，其中一段关于加班的独白在社交平台被反复转发。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20a%20spotlight%20on%20an%20empty%20stage%20with%20a%20vintage%20microphone%2C%20deep%20burgundy%20and%20warm%20gold%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n09&orientation=landscape',
    content: [
      '第五期《喜剧工坊》以“我的工作”为题，四组演员分别从外卖、客服、设计和对冲基金的角度写了自己的段子。',
      '其中新人演员小鹿的一段独白成为本期讨论度最高的内容。她把加班形容成“一场没人宣布结束的考试”，现场安静了两秒才响起掌声。',
      '评委老段在点评时说，好的喜剧不是把苦说成笑话，而是让人笑完之后承认“这确实很苦”。',
      '本期完整内容已在黄牛视频更新，节目每周四播出。',
    ],
  },
  {
    id: 'n10',
    title: '《潮汐之城》幕后：一场台风戏拍了十一个夜晚',
    category: '电影',
    publishedAt: '2026-09-30',
    source: '影迷手记',
    summary:
      '《潮汐之城》发布幕后特辑，导演苏未央讲述那场贯穿全片的台风戏如何在真实海风里完成，以及为什么最终删掉了三分之二的台词。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cinematic%20image%20of%20a%20stormy%20seaside%20pier%20with%20waves%20and%20sea%20spray%2C%20teal%20and%20warm%20sand%20palette%2C%20stylized%2C%20no%20text&width=800&height=500&seq=hn-n10&orientation=landscape',
    content: [
      '《潮汐之城》幕后特辑今日上线。特辑的核心是那场持续了十一夜的台风戏，全组在真实的海风与降雨中完成了主要镜头。',
      '导演苏未央说，原本这场戏有大量对白，但在剪辑时被删掉了三分之二：“风太大的时候，人是不会说那么多话的，他们只会看着对方。”',
      '摄影指导提到，为了保留真实的海雾，剧组放弃了大量补光，很多镜头只能靠路灯和远处的渔船照明完成，感光度被推到极限。',
      '影片目前已在黄牛视频上线完整资料与幕后内容。',
    ],
  },
];